// src/utils/useAuth.js
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getToken, clearToken } from "./auth";
import { message } from "antd";

export default function useAuth() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = getToken();

    // Si el token no existe o es inválido
    if (!token || token === "undefined" || token === "null" || token === "") {
      clearToken();
      message.warning(
        "Su sesión ha expirado o no tiene acceso, por favor inicie sesión nuevamente."
      );
      navigate("/login", { replace: true });
    }
  }, [navigate]);
}
